import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PatchFarmAdvertisement from '.';

interface IPatchFarmAdvertisementProps {
  onSuccess?: (data: any) => void;
  guid?: string;
}

const usePatchFarmAdvertisement = ({
  onSuccess,
  guid,
}: IPatchFarmAdvertisementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IFarmAdvertisementPayload) => {
      return PatchFarmAdvertisement(payload, guid);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePatchFarmAdvertisement};
